import React from 'react'
import PropTypes from 'prop-types'

import AgeDistribution from '_components/audience-insights/charts/age-distribution'
import useRect from '../hooks/useRect'

const formatToPPT = (data) => data.map((item) => ({ ...item, value: item.value / 100 }))

function AgeDistributionHOC({ data }) {
  const [Rect, rect] = useRect()

  return (
    <>
      <Rect />
      <foreignObject
        x="0"
        y="0"
        width={rect.width}
        height={rect.height}
        data-custom-render="ai-chart-bar"
        data-json={JSON.stringify(formatToPPT(data))}
      >
        <AgeDistribution data={data} width={rect.width} height={rect.height} />
      </foreignObject>
    </>
  )
}

AgeDistributionHOC.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    })
  ).isRequired,
}

AgeDistributionHOC.defaultProps = {}

export default AgeDistributionHOC
